import * as React from "react";

import { ITheme } from "@fluentui/react/lib/Styling";

import {
  AppPreviewGallery,
  AppPreviewGalleryInternalProps,
  getAppGalleryStyles,
} from "@1js/acui-gallery";
import { AppThemeConsumer } from "@1js/acui-theme";

import { getFontStyleGalleryStyles } from "../AppFontStylesFullGallery/AppFontStylesFullGallery.styles";
import { AppFontStylesGalleryButtonProps } from "../AppFontStylesGalleryButton";
import { AppFontStylesPreviewGalleryButton } from "../AppFontStylesPreviewGalleryButton";
import { AppFontStylesPreviewGalleryProps } from "./AppFontStylesPreviewGallery.Props";

export class AppFontStylesPreviewGallery extends React.PureComponent<
  AppFontStylesPreviewGalleryProps &
    AppPreviewGalleryInternalProps<AppFontStylesGalleryButtonProps>,
  {}
> {
  public render() {
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <AppPreviewGallery
            {...this.props}
            styles={getAppGalleryStyles(
              theme,
              getFontStyleGalleryStyles(theme, this.props.styles)
            )}
            getGalleryButtonComponent={
              this.props.getGalleryButtonComponent ||
              AppFontStylesPreviewGalleryButton
            }
            automationType={
              this.props.dataAutomationType || "AppFontStylesPreviewGallery"
            }
            uniqueId={this.props.id}
          />
        )}
      </AppThemeConsumer>
    );
  }
}
